import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CitiesService } from 'src/app/services/cities.service';
import { CitiesModalComponent } from './cities-modal/cities-modal.component';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';

@Component({
  selector: 'app-cities',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './cities.component.html',
  styleUrls: ['./cities.component.css']
})
export class CitiesComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private CitiesService: CitiesService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  CitiesList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getCities();
  }

  getCities(){
    this.CitiesService.getCities().subscribe({
      next: (res: any) => {
        this.CitiesList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error al cargar ciudades:', err);
        this.filteredData = [];
      }
    });
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(CitiesModalComponent, {
      data: { item, mode, title },
      maxWidth: '100%',
      width: '40%',
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getCities();
        }
      }
    });
  }

}
